/* HALE HERBALS — homepage scroll-reveal (index template only).
   Self-contained: injects its own CSS, respects reduced-motion. */
(function(){
  if(!document.body || document.body.className.indexOf('template-index')===-1) return;
  if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if(!('IntersectionObserver' in window)) return;

  var css='.hale .rv{opacity:0;transform:translateY(16px);transition:opacity .6s ease,transform .6s cubic-bezier(.22,.61,.36,1);}'+
          '.hale .rv.rv-in{opacity:1;transform:none;}';
  var st=document.createElement('style'); st.textContent=css; document.head.appendChild(st);

  var SEL=[
    '.hale .sec-head',
    '.hale .prod-card',
    '.hale .sol',
    '.hale .rit-step',
    '.hale .cert',
    '.hale .feature',
    '.hale .rev',
    '.hale .stat',
    '.hale .badge'
  ].join(',');

  function collect(){ return [].slice.call(document.querySelectorAll(SEL)); }

  var io=new IntersectionObserver(function(es){
    es.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('rv-in'); io.unobserve(en.target); } });
  },{rootMargin:'0px 0px -8% 0px'});

  function arm(){
    collect().forEach(function(el,i){
      if(el.__rv) return; el.__rv=1;
      el.classList.add('rv');
      el.style.transitionDelay=((i%4)*70)+'ms';
      io.observe(el);
    });
  }
  if(document.readyState!=='loading') arm(); else document.addEventListener('DOMContentLoaded',arm);
  /* re-arm after theme sections / lazy content load */
  setTimeout(arm,800); setTimeout(arm,2000);
  document.addEventListener('shopify:section:load',arm);
})();
